/**
 * Footer API functions
 */

import { FooterData, StrapiResponse } from '../types';
import { STRAPI_URL } from './base';

/**
 * Fetch footer data
 * @returns Promise with footer data
 */
export async function fetchFooterData(): Promise<FooterData> {
  try {
    const response = await fetch(`${STRAPI_URL}/api/footer`, {
      headers: {
        'Content-Type': 'application/json',
        ...(process.env.NEXT_PUBLIC_STRAPI_API_TOKEN && {
          Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
        }),
      },
    });

    if (!response.ok) {
      console.error('HTTP error! status:', response.status);
      throw new Error(`Failed to fetch footer data: ${response.status}`);
    }

    const result: StrapiResponse<FooterData> = await response.json();

    if (!result.data) {
      console.error(
        'Footer data is null or undefined. Full response:',
        JSON.stringify(result, null, 2)
      );
      throw new Error('No footer data found');
    }

    return result.data;
  } catch (error) {
    console.error('Error fetching footer data:', error);
    throw error;
  }
}
